import Vue from 'vue'
import VueRouter from 'vue-router'
import { getDeviceUUID } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    hidden: true,
    component: () => import('@/views/Home'),
    redirect: 'IPTest',
    children: [
      {
        path: '/IPTest',
        name: 'IPTest',
        hidden: true,
        component: () => import('@/views/IPTest')
      }
      // {
      //   path: '',
      //   name: 'WebTest',
      //   hidden: true,
      //   component: () => import('@/views/WebTest')
      // }
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: '/z/',
  routes
})

// const whiteList = ['/', '/z', '/y', '/speedtestempty/']
// 路由守卫
router.beforeEach((to, from, next) => {
  getDeviceUUID()
  console.log(to.path)
  // if (whiteList.indexOf(to.path.toLowerCase()) !== -1) {
    next()
  // } else {
  //   next('/')
  // }
})

export default router
